import { Tag } from "antd";
import styled from "styled-components";

export const StyledFacetFilterTagsContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
`;

export const StyledTag = styled(Tag)`
    padding: 8px;
    margin: 0;
`;
